// extracted by mini-css-extract-plugin
module.exports = {"root":"IconHelp_root__1fzZP"};